
















import { Component, Vue } from 'vue-property-decorator'
import VinylePochette from '../components/VinylePochette.vue'
import PochetteSection from '../components/PochetteSection.vue'
import ProgramSection from '../components/ProgramSection.vue'
import { news as fetchNews } from '../services/news-service'
import { News } from '@/models/news'
import { coverURL as getCoverURL } from '@/services/cover-service'

@Component({
  components: { VinylePochette, PochetteSection, ProgramSection },
  props: {
    now: Object
  }
})
export default class Home extends Vue {
  private news: News[] = []

  get coverURL (): string | null {
    if (this.$props.now && this.$props.now.song && this.$props.now.song.cover) {
      return getCoverURL(this.$props.now.song.cover)
    }
    return null
  }

  private async loadNews () {
    this.news = await fetchNews()
  }

  mounted () {
    this.loadNews().then()
  }
}
